module.exports = __webpack_public_path__ + "img/Ptuapp1.d319bc92.png";